// Aquí está el slice de autenticación con verificación de token al inicializar
import { createSlice, createAsyncThunk, isRejected } from "@reduxjs/toolkit";
import api from "@/services/api";
import { updateImgPerfil } from "../user/userThunks";
import { refreshAccessToken } from "./authThunks";

// Thunk para verificar token al inicializar
export const verifyToken = createAsyncThunk(
  "auth/verifyToken",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/auth/verify");
      return response.data;
    } catch (error) {
      return rejectWithValue("Token inválido");
    }
  }
);

const initialState = {
  user: null,
  accessToken: null,
  idToken: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      // debugger;
      console.log("Payload de loginSuccess:", state, action);
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.idToken = action.payload.idToken;
      state.isAuthenticated = true;
      state.error = null;
      state.isLoading = false;
    },
    loginFailure: (state, action) => {
      // debugger;
      state.error = action.payload;
    },
    loginReset: (state) => {
      // debugger;
      state.error = null;
    },
    logout: (state) => {
      // debugger;
      state.user = null;
      state.accessToken = null;
      state.idToken = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    updateImgPerfilUser: (state, action) => {
      state.user = {
        ...state.user,
        imgPerfil: action.payload.imgPerfil,
      };
    },
    updateUserBasicInfo: (state, action) => {
      const p = action.payload;
      state.user = {
        ...state.user,
        ...(p.nombre !== undefined && { nombre: p.nombre }),
        ...(p.apellido !== undefined && { apellido: p.apellido }),
        ...(p.correo !== undefined && { correo: p.correo }),
        ...(p.numeroTributario !== undefined && { numeroTributario: p.numeroTributario }),
        ...(p.tipoDocumento !== undefined && { tipoDocumento: p.tipoDocumento }),
        ...(p.numeroPasaporte !== undefined && { numeroPasaporte: p.numeroPasaporte }),
      };
    },
    clearError: (state) => {
      // debugger;
      state.error = null;
    },
  },
});

export const { loginSuccess, loginFailure, loginReset, logout, clearError, updateImgPerfilUser, updateUserBasicInfo } =
  authSlice.actions;
export default authSlice.reducer;
